import React from "react";
import styled from "styled-components";
import { Alert, Col, Row } from "components/bootstrap";
import useStreamsByIndexSet from "components/inputs/InputSetupWizard/hooks/useStreamsByIndexSet";
const StyledAlert = styled(Alert)`
  margin-top: 0;
  margin-bottom: 0;
`;
const SelectedIndexSetAlert = ({ selectedIndexSetId = void 0, indexSets }) => {
  const { data: streamsByIndexSetIdData } = useStreamsByIndexSet(selectedIndexSetId, !!selectedIndexSetId);
  const isDefaultIndexSet = () => {
    var _a;
    const indexSet = indexSets == null ? void 0 : indexSets.find(({ id }) => id === selectedIndexSetId);
    return (_a = indexSet == null ? void 0 : indexSet.default) != null ? _a : false;
  };
  const isAlreadyUsedByStreams = () => {
    if (!streamsByIndexSetIdData) return false;
    return streamsByIndexSetIdData.total > 0;
  };
  if (!selectedIndexSetId) return null;
  if (isDefaultIndexSet()) {
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledAlert, { title: "Default Index Set selected", bsStyle: "info" }, "You have selected the Default Index Set.", /* @__PURE__ */ React.createElement("br", null), "We recommend against this: as the potential recipient of messages of many different formats (any message with no routing, via the Default Stream), the Default Index Set is susceptible to reaching the maximum per-Index field limit of the search backend if used extensively.")));
  }
  if (isAlreadyUsedByStreams()) {
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alert, { title: "Selected index set already associated with another stream", bsStyle: "info" }, "The selected index set is already associated with another stream(s).", /* @__PURE__ */ React.createElement("br", null), "Note that each Index has a unique field limit, defaulting to 1000.", /* @__PURE__ */ React.createElement("br", null), "For this reason, we recommend that streams be organised by log format across multiple Index Sets where possible.")));
  }
  return null;
};
export default SelectedIndexSetAlert;
